// Add global typings to make TypeScript happy with window.cohesion and window.monarch
declare global {
  interface Window {
    cohesion: (event: string, callback: () => void) => void
    monarch: (
      type: string,
      ruleId: string,
      contexts: Record<string, unknown>,
      options: Record<string, unknown>,
      callback: (err: Error | null, result: Record<string, any> | null) => void
    ) => void
  }
}

// Template mapping configuration for welcome page variants
const TEMPLATE_MAP = {
  'Form Landing Page | Welcome Screen v1 | Pop Experience': 'pop',
  'Form Landing Page | Welcome Screen v1 | Simple Experience': 'simple',
}

/**
 * Evaluates the welcome page variant using the monarch service
 * @returns The template identifier: 'pop', 'simple', or 'default'
 */
export async function evaluateWelcomePageVariant(): Promise<string> {
  try {
    return new Promise((resolve) => {
      window.cohesion('monarch:ready', function () {
        window.monarch(
          'rule',
          'sageFormLandingPageWelcomeScreenV1',
          {},
          {},
          function (err, result) {
            if (err) {
              resolve('default')
            } else {
              const monarchResult = result.sageFormLandingPageWelcomeScreenV1
              resolve(
                monarchResult
                  ? TEMPLATE_MAP[monarchResult] || 'default'
                  : 'default'
              )
            }
          }
        )
      })
    })
  } catch (error) {
    console.error('Error evaluating welcome page variant:', error)
    return 'default'
  }
}

// Template mapping configuration for welcome page variants
const TEMPLATE_MAP_V2 = {
  'Form Landing Page | Welcome Screen v2 | Pop Experience': 'popV2',
  'Form Landing Page | Welcome Screen v2 | Simple Experience': 'simpleV2',
}

/**
 * Evaluates the welcome page variant using the monarch service
 * @returns The template identifier: 'pop', 'simple', or 'default'
 */
export async function evaluateWelcomePageVariantV2(): Promise<string> {
  try {
    return new Promise((resolve) => {
      window.cohesion('monarch:ready', function () {
        window.monarch(
          'rule',
          'sageFormLandingPageWelcomeScreenV2',
          {},
          {},
          function (err, result) {
            if (err) {
              resolve('default')
            } else {
              const monarchResult = result.sageFormLandingPageWelcomeScreenV2
              resolve(
                monarchResult
                  ? TEMPLATE_MAP_V2[monarchResult] || 'default'
                  : 'default'
              )
            }
          }
        )
      })
    })
  } catch (error) {
    console.error('Error evaluating welcome page variant:', error)
    return 'default'
  }
}
